import { combineReducers } from 'redux'

import accountTakeOverClassificationReducer from './AccountTakeOverClassificationModal/reducer'
import accountTakeOverModalReducer from './AccountTakeOverModal/reducer'
import affMailboxesDetailReducer from './AffMailboxesDetail/reducer'
import atoIncidentHeaderReducer from './AtoIncident/Header/reducer'
import atoIncidentReducer from './AtoIncident/reducer'
import incidentFiltersReducer from './IncidentFilters/reducer'
import listReducer from './List/reducer'
import mailboxInfoModalReducer from './MailboxInfoModal/reducer'
import quickFiltersReducer from './QuickFilters/reducer'
import remediatedIncidentsReducer from './RemediatedIncidents/reducer'
import reportReducer from './Report/reducer'
import reportCommentsReducer from './ReportComments/reducer'
import reportCommunicationModalReducer from './ReportCommunicationModal/reducer'
import reportedIncidentsReducer from './ReportedIncidents/reducer'
import resolutionReducer from './Resolution/reducer'
import resolutionModalReducer from './ResolutionModal/reducer'
import scanBackReducer from './ScanBack/reducer'
import scannerDetailReducer from './ScannerDetail/reducer'
import serverScanReducer from './ServerScan/reducer'
import tagsClassificationReducer from './TagsClassification/reducer'
import topBarReducer from './TopBar/reducer'

function resolutionCenterReducer() {
  const initialState = {
    loader: false,
    isDataLoaded: true,
    error: null,
  }

  return (state = initialState, action) => {
    switch (action.type) {
      default:
        return state
    }
  }
}
export default function () {
  const initialState = combineReducers({
    self: resolutionCenterReducer(),
    resolution: resolutionReducer(),
    resolutionModal: resolutionModalReducer(),
    topBar: topBarReducer(),
    quickFilters: quickFiltersReducer(),
    list: listReducer(),
    incidentFilters: incidentFiltersReducer(),
    report: reportReducer(),
    atoIncident: atoIncidentReducer(),
    atoIncidentHeader: atoIncidentHeaderReducer(),
    remediatedIncidents: remediatedIncidentsReducer(),
    reportedIncidents: reportedIncidentsReducer(),
    serverScan: serverScanReducer(),
    scannerDetail: scannerDetailReducer(),
    tagsClassification: tagsClassificationReducer(),
    affMailboxesDetail: affMailboxesDetailReducer(),
    reportComments: reportCommentsReducer(),
    reportCommunicationModal: reportCommunicationModalReducer(),
    scanBack: scanBackReducer(),
    mailboxInfoModal: mailboxInfoModalReducer(),
    accountTakeOverModal: accountTakeOverModalReducer(),
    accountTakeOverClassificationModal: accountTakeOverClassificationReducer(),
  })

  return (state = initialState, action) => {
    switch (action.type) {
      default:
        return state
    }
  }
}
